import { withRouter } from "react-router-dom";

import { useScrollToTop } from "hooks";

// TODO: Not used. Remove this component?
const ScrollToTop = ({ children, location: { pathname } }) => {
	useScrollToTop(pathname);

	return children || null;
};

export default withRouter(ScrollToTop);
